import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[DESIGN PARTNERS]';

export default {
    ...ActionsBuilder.buildList(IDENTIFIER, false, true, true)
};